<template>
  <MainLayout>
    <div class="certificado-modern">
      <PageHeader
        icon="ri-award-line"
        title="Solicitud de Certificado"
        subtitle="Validación de datos para emisión de Certificado"
        :show-button="false" />

      <!-- Contenido Principal -->
      <div class="certificate-container">
        <!-- Validación de Datos -->
        <div v-if="certificado && certificado.codigo == 'ok'" class="validation-card">
          <div class="validation-intro">
            <div class="validation-intro-icon">
              <i class="ri-shield-check-line"></i>
            </div>
            <div class="validation-intro-copy">
              <span class="validation-kicker">Revisión de información</span>
              <h2>Confirma tus datos</h2>
              <p>Verifica cada dato antes de solicitar la emisión de tu certificado.</p>
            </div>
            <span class="validation-step">Paso 1</span>
          </div>

          <div v-if="certificado.dato" class="validation-content">
            
            <!-- Tipo de Documento -->
            <div class="validation-item">
              <span class="question-label">¿Su tipo de documento es correcto?</span>
              <div class="validation-details">
                <span class="question-value">{{ tipodocumento }}</span>
                <div class="validation-controls">
                  <div class="radio-group">
                    <label class="radio-button" :class="{ active: estudianteTipodocumento === 'SI', success: estudianteTipodocumento === 'SI' }">
                      <input type="radio" v-model="estudianteTipodocumento" value="SI" @change="correccion_informacion.tipo_documento = getTipodocumento">
                      <span>SI</span>
                    </label>
                    <label class="radio-button" :class="{ active: estudianteTipodocumento === 'NO', danger: estudianteTipodocumento === 'NO' }">
                      <input type="radio" v-model="estudianteTipodocumento" value="NO" @change="correccion_informacion.tipo_documento = getTipodocumento">
                      <span>NO</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Selector de Tipo de Documento -->
            <div v-if="estudianteTipodocumento == 'NO'" class="correction-field">
              <label class="field-label">Seleccione el tipo de documento:</label>
              <select v-model="correccion_informacion.tipo_documento" class="modern-select">
                <option disabled value="">Por favor, seleccione</option>
                <option v-for="td in tipos_documentos" :key="td.codigo" :value="td.codigo">
                  {{ td.descripcion }}
                </option>
              </select>
            </div>

            <!-- Número de Documento -->
            <div class="validation-item">
              <span class="question-label">¿Su número de documento es correcto?</span>
              <div class="validation-details">
                <span class="question-value">{{ certificado.dato.numero_documento }}</span>
                <div class="validation-controls">
                  <div class="radio-group">
                    <label class="radio-button" :class="{ active: estudianteDocumento === 'SI', success: estudianteDocumento === 'SI' }">
                      <input type="radio" v-model="estudianteDocumento" value="SI">
                      <span>SI</span>
                    </label>
                    <label class="radio-button" :class="{ active: estudianteDocumento === 'NO', danger: estudianteDocumento === 'NO' }">
                      <input type="radio" v-model="estudianteDocumento" value="NO">
                      <span>NO</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Nombre Completo -->
            <div class="validation-item">
              <span class="question-label">¿Su nombre completo es correcto?</span>
              <div class="validation-details">
                <span class="question-value">
                  {{ certificado.dato.primer_nombre }} {{ certificado.dato.segundo_nombre }} 
                  {{ certificado.dato.primer_apellido }} {{ certificado.dato.segundo_apellido }}
                </span>
                <div class="validation-controls">
                  <div class="radio-group">
                    <label class="radio-button" :class="{ active: estudianteNombre === 'SI', success: estudianteNombre === 'SI' }">
                      <input type="radio" v-model="estudianteNombre" value="SI" 
                        @change="correccion_informacion.primer_nombre = certificado.dato.primer_nombre; 
                                 correccion_informacion.segundo_nombre = certificado.dato.segundo_nombre; 
                                 correccion_informacion.primer_apellido = certificado.dato.primer_apellido; 
                                 correccion_informacion.segundo_apellido = certificado.dato.segundo_apellido">
                      <span>SI</span>
                    </label>
                    <label class="radio-button" :class="{ active: estudianteNombre === 'NO', danger: estudianteNombre === 'NO' }">
                      <input type="radio" v-model="estudianteNombre" value="NO"
                        @change="correccion_informacion.primer_nombre = certificado.dato.primer_nombre; 
                                 correccion_informacion.segundo_nombre = certificado.dato.segundo_nombre; 
                                 correccion_informacion.primer_apellido = certificado.dato.primer_apellido; 
                                 correccion_informacion.segundo_apellido = certificado.dato.segundo_apellido">
                      <span>NO</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="validation-item">
              <span class="question-label">¿El email para envío del certificado es correcto?</span>
              <div class="validation-details">
                <span class="question-value">{{ certificado.dato.email }}</span>
                <div class="validation-controls">
                  <div class="radio-group">
                    <label class="radio-button" :class="{ active: estudianteCorreo === 'SI', success: estudianteCorreo === 'SI' }">
                      <input type="radio" v-model="estudianteCorreo" value="SI" 
                        @change="correccion_informacion.email_adicional = certificado.dato.email_adicional">
                      <span>SI</span>
                    </label>
                    <label class="radio-button" :class="{ active: estudianteCorreo === 'NO', danger: estudianteCorreo === 'NO' }">
                      <input type="radio" v-model="estudianteCorreo" value="NO"
                        @change="correccion_informacion.email_adicional = certificado.dato.email_adicional">
                      <span>NO</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Campo Email Adicional -->
            <div v-if="estudianteCorreo == 'NO' || (certificado.dato && certificado.dato.email_adicional)" class="correction-field">
              <label class="field-label">Introduzca un correo adicional:</label>
              <input type="email" v-model="correccion_informacion.email_adicional" 
                :readonly="estudianteCorreo == 'SI'" class="modern-input">
            </div>

            <!-- Alerta de Datos Sensibles -->
            <div v-if="estudianteNombre == 'NO' || estudianteDocumento == 'NO'" class="alert-warning">
              <i class="ri-error-warning-line"></i>
              <div class="alert-content">
                <strong>Atención:</strong> Los campos <strong>nombres completos</strong> y <strong>número de documento</strong> 
                son datos sensibles. Para modificarlos, debe realizar la solicitud en la recepción de su sede más cercana 
                o enviar una PQRS para la actualización de su información.
              </div>
            </div>

            <!-- Confirmación Final -->
            <div v-if="validos" class="confirmation-section">
              <div class="confirmation-message" v-html="mensaje"></div>

              <div class="confirmation-data">
                <div v-if="estudianteTipodocumento == 'SI'" class="data-item">
                  <strong>Tipo de documento:</strong> {{ tipodocumento }}
                </div>
                <div v-if="estudianteDocumento == 'SI'" class="data-item">
                  <strong>Número de documento:</strong> {{ certificado.dato.numero_documento }}
                </div>
                <div v-if="estudianteNombre == 'SI'" class="data-item">
                  <strong>Nombre Completo:</strong> {{ certificado.dato.primer_nombre }} {{ certificado.dato.segundo_nombre }} 
                  {{ certificado.dato.primer_apellido }} {{ certificado.dato.segundo_apellido }}
                </div>
                <div v-if="estudianteCorreo == 'SI'" class="data-item">
                  <strong>Correo de envío:</strong> {{ certificado.dato.email_adicional ? certificado.dato.email_adicional : certificado.dato.email }}
                </div>
              </div>

              <div class="alert-info">
                <i class="ri-information-line"></i>
                <div class="alert-content">
                  Al <strong>ACEPTAR</strong> se emitirá el certificado a su correo electrónico registrado. 
                  Este certificado es gratuito. Si requiere una corrección después de emitido, deberá solicitarlo 
                  en la página web como duplicado de certificado pagando el valor correspondiente.
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Mensaje de Error o Estado -->
        <div v-else class="message-card" >
          <div v-html="mensaje"></div>
          <div class="mt-2">
              <p>
                Si no te ha llegado el correo, puedes darle clic a esta url para descargar tu certificado
                <b-link :href="url" target="_blank">{{url}}</b-link>
              </p>
          </div>
              
        </div>

        <!-- Botones de Acción -->
        <div class="action-buttons">
          <button class="btn-action btn-danger" @click="regresar()">
            <i class="ri-arrow-left-line"></i>
            Salir
          </button>

          <button v-if="!validos && certificado && certificado.codigo == 'ok'"
            :disabled="(tipoDocumentoIgual && correoAdicionalIgual)" 
            class="btn-action btn-info" 
            @click="guardar()">
            <i class="ri-save-line"></i>
            Guardar
          </button>

          <button v-if="validos && (certificado && certificado.codigo == 'ok')"
            :disabled="certificado.generado || !(estudianteTipodocumento == 'SI' && estudianteDocumento == 'SI' && estudianteNombre == 'SI' && estudianteCorreo == 'SI')"
            class="btn-action btn-success" 
            @click="procesar()">
            <i class="ri-check-line"></i>
            Aceptar
          </button>
        </div>
      </div>

      <!-- Modal -->
      <transition name="modal-fade">
        <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
          <div class="modal-content">
            <div class="modal-header">
              <h2>Atención</h2>
              <button class="btn-close-modal" @click="showModal = false">
                <i class="ri-close-line"></i>
              </button>
            </div>
            <div class="modal-body">
              <p>{{ mensajeTransition }}</p>
            </div>
            <div class="modal-footer">
              <button class="btn-action btn-primary" @click="showModal = false">Cerrar</button>
            </div>
          </div>
        </div>
      </transition>

    </div>
  </MainLayout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { validationMixin } from 'vuelidate'
import MainLayout from '@/components/Layout/MainLayout.vue';
import PageHeader from '@/components/Layout/PageHeader.vue';

export default {
  components: {
    MainLayout,
    PageHeader
  },
  mixins: [validationMixin],
  name: 'SolicitarCertificadoPage',
  data() {
    return {
      nivel_siguiente: null,
      paso: 1,
      sede_id: null,
      mensaje: null,
      form: null,
      procesando: false,
      codigo: null,
      virtual: false,
      mensajeTransition: null,
      showModal: false,
      certificado: null,
      estudianteTipodocumento: null,
      estudianteDocumento: null,
      estudianteNombre: null,
      estudianteCorreo: null,
      correccion_informacion: {
        tipo_documento: '',
        primer_nombre: '',
        segundo_nombre: '',
        primer_apellido: '',
        segundo_apellido: '',
        email_adicional: ''
      }
    }
  },
  mounted() {
    this.fetchTipoDocumento()
    this.cursoFinalizado();
  },
  methods: {
    ...mapActions({
      fetchDisponibilidad: 'academico/fetchDisponibilidad',
      fetchCertificarNivel: 'academico/fetchCertificarNivel',
      fetchTipos: 'academico/fetchTipos',
      fetchInformacion: 'student/informacion',
      generarCertificado: 'academico/generarCertificado',
      fetchSedeActual: 'academico/fetchSedeActual',
      consultarCertificado: 'academico/consultarCertificado',
      fetchTipoDocumento: 'tipoDocumento/fetchLista',
      save: 'student/guardar',
    }),
    ...mapMutations({
      setShowNotification: 'setShowNotification',
      setWarning: 'setWarning',
    }),
    regresar() {
      this.$router.push(`/`)
    },
    procesar() {
      this.generarCertificado({ cambio_nivel_id: this.certificado.dato.curso_actual.id }).then((result) => {
        this.mensajeTransition = result.message ? result.message : mensaje;
        this.certificado.generado = result.result;
        this.showModal = true;
        if (result.result) {

        } else {
        }
      }).catch((err) => {
        console.err(err)
      }).finally(() => {
        this.procesando = false;
      })
    },
    consultar(dato) {
      this.consultarCertificado({cambio_nivel_id:dato.id}).then((result)=>{
        this.mensaje = result.message
        this.url = result.data && result.data.url ? result.data.url : null;
      }).catch((err) => {
        console.err(err)
      }).finally(() => {
          this.procesando = false;
      })
    },
    cursoFinalizado() {
      this.fetchCertificarNivel().then((result) => {
        this.certificado = result;
        if (result.dato && result.dato.email_adicional) {
          this.correccion_informacion.email_adicional = result.dato.email_adicional;
          this.correccion_informacion.primer_nombre = result.dato.primer_nombre;
          this.correccion_informacion.primer_apellido = result.dato.primer_apellido;
          this.correccion_informacion.segundo_nombre = result.dato.segundo_nombre;
          this.correccion_informacion.segundo_apellido = result.dato.segundo_apellido;
          this.correccion_informacion.tipo_documento = result.dato.tipo_documento;
          this.correccion_informacion.numero_documento = result.dato.numero_documento;
        }
        this.mensaje = result.mensaje;
        if (result.codigo === "solicitado") {
          this.consultar(result.dato)
        }
      }).catch((err) => {
        console.error(err)
        this.mensaje = err.mensaje ? err.mensaje : "Ocurrio un error inesperado, intentelo más tarde";
      })
    },
    consultarNotas() {
      this.fetchInformacion().then((result) => {
        this.form = result;
      }).catch((error) => {
        console.error(error)
      })
    },
    guardar() {
      this.save(this.correccion_informacion).then((result) => {
        if (result.mensaje) this.setWarning(result.mensaje)
        if (result.dato) {
          for (var i in result.dato) {
            this.certificado.dato[i] = result.dato[i];
            this.correccion_informacion[i] = result.dato[i];
          }
          this.estudianteTipodocumento = "SI"
          this.estudianteCorreo = "SI"
        }
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      siguienteTema: state => state.academico.siguienteTema,
      tipos_documentos: state => state.tipoDocumento.lista,
      sedes: state => state.sedes.lista,
    }),
    ...mapGetters({
    }),
    sedesFiltradas() {
      if (this.virtual) {
        return this.sedes.filter(element => {
          return element.es_virtual == 1
        })
      } else {
        return this.sedes.filter(element => {
          return element.es_virtual == 0
        })
      }
    },
    tipodocumento() {
      if (this.certificado && this.certificado.dato && this.certificado.dato.tipo_documento) {
        let item = this.tipos_documentos.find(x => x.codigo == this.certificado.dato.tipo_documento);
        if (item) {
          return item.descripcion;
        } else {
          return this.certificado.dato.tipo_documento;
        }
      }
      return null;
    },
    getTipodocumento() {
      if (this.certificado && this.certificado.dato && this.certificado.dato.tipo_documento) {
        return this.certificado.dato.tipo_documento;
      }
      return null;
    },
    validos() {
      return this.estudianteTipodocumento == 'SI' && this.estudianteDocumento == 'SI' && this.estudianteNombre == 'SI' && this.estudianteCorreo == 'SI';
    },
    tipoDocumentoIgual() {
      return this.certificado && this.certificado.dato && this.correccion_informacion.tipo_documento === this.certificado.dato.tipo_documento
    },
    correoAdicionalIgual() {
      return this.certificado && this.certificado.dato && this.correccion_informacion.email_adicional === this.certificado.dato.email_adicional
    }

  }

}
</script>

<style scoped>
/* Container Principal */
.certificado-modern {
  background: var(--theme-gradient-bg);
  min-height: 100vh;
  padding-bottom: 2rem;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Container de Certificado */
.certificate-container {
  max-width: 980px;
  margin: 0.75rem auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 1;
}

/* Card de Validación */
.validation-card {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-shadow: var(--theme-shadow-md);
  backdrop-filter: var(--theme-backdrop-blur);
  animation: fadeInUp 0.6s ease-out;
}

.validation-intro {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.25rem 0 0.875rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--theme-border-color-light);
}

.validation-intro-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  background: var(--theme-gradient-primary);
  border-radius: 10px;
  color: var(--app-header-text);
  font-size: 1.25rem;
  box-shadow: var(--theme-shadow-sm);
}

.validation-intro-copy {
  min-width: 0;
  flex: 1;
}

.validation-kicker {
  display: block;
  margin-bottom: 0.125rem;
  color: var(--app-primary-blue);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.validation-intro-copy h2 {
  margin: 0;
  color: var(--theme-text-primary);
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.2;
}

.validation-intro-copy p {
  margin: 0.2rem 0 0;
  color: var(--theme-text-secondary);
  font-size: 0.78rem;
  line-height: 1.35;
}

.validation-step {
  align-self: flex-start;
  padding: 0.3rem 0.55rem;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 999px;
  color: var(--theme-text-muted);
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.validation-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Item de Validación */
.validation-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  padding: 0.7rem 0.875rem;
  background: var(--theme-hover-bg-light);
  border-radius: 8px;
  border: 1px solid var(--theme-border-color);
  transition: all 0.3s ease;
}

.validation-item:hover {
  border-color: var(--theme-border-color-strong);
  box-shadow: var(--theme-shadow-sm);
}

.validation-details {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  width: 100%;
}

.question-label {
  display: block;
  font-weight: 600;
  color: var(--theme-text-primary);
  font-size: 0.85rem;
  line-height: 1.35;
}

.question-value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: var(--theme-text-primary);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  background: var(--theme-color-cyan-alpha-30);
  border-radius: 6px;
  border-left: 3px solid var(--app-primary-blue);
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.validation-controls {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
}

/* Radio Group */
.radio-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
  flex-direction: row;
}

.radio-button {
  position: relative;
  flex: 0 0 auto;
  cursor: pointer;
  user-select: none;
  margin: 0;
}

.radio-button input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.radio-button span {
  display: inline-block;
  padding: 0.35rem 1.25rem;
  background: var(--theme-input-bg);
  border: 2px solid var(--theme-border-color);
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  min-width: 80px;
  text-align: center;
  color: var(--theme-text-primary);
}

.radio-button:hover span {
  border-color: var(--theme-border-color-strong);
}

.radio-button.active.success span {
  background: var(--theme-color-success);
  color: white;
  border-color: var(--theme-color-success);
}

.radio-button.active.danger span {
  background: var(--theme-color-danger);
  color: white;
  border-color: var(--theme-color-danger);
}

/* Campos de Corrección */
.correction-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.7rem 0.875rem;
  background: var(--theme-hover-bg-light);
  border-radius: 10px;
  border: 1px solid var(--theme-border-color);
  animation: slideDown 0.3s ease-out;
}

.field-label {
  font-weight: 600;
  color: var(--theme-text-primary);
  font-size: 0.85rem;
}

.modern-select,
.modern-input {
  padding: 0.6rem 0.875rem;
  background: var(--theme-input-bg);
  border: 1px solid var(--theme-border-color);
  border-radius: 6px;
  color: var(--theme-text-primary);
  font-size: 0.875rem;
  transition: all 0.3s ease;
  width: 100%;
}

.modern-select option {
  background: var(--theme-input-bg);
  color: var(--theme-text-primary);
  padding: 0.5rem;
}

.modern-select:focus,
.modern-input:focus {
  outline: none;
  border-color: var(--app-primary-blue);
  box-shadow: 0 0 0 3px var(--theme-color-cyan-alpha-20);
}

.modern-select:focus option {
  background: var(--theme-bg-secondary);
  color: var(--theme-text-primary);
}

.modern-input:readonly {
  background: var(--theme-hover-bg-light);
  cursor: not-allowed;
  opacity: 0.7;
}

/* Alertas */
.alert-warning,
.alert-info {
  display: flex;
  gap: 0.75rem;
  padding: 0.7rem 0.875rem;
  border-radius: 8px;
  animation: slideDown 0.3s ease-out;
}

.alert-warning {
  background: linear-gradient(135deg, rgba(241, 196, 0, 0.2) 0%, rgba(255, 193, 7, 0.2) 100%);
  border: 1px solid rgba(241, 196, 0, 0.4);
  color: var(--theme-text-primary);
}

.alert-info {
  background: linear-gradient(135deg, rgba(79, 172, 254, 0.2) 0%, rgba(0, 242, 254, 0.2) 100%);
  border: 1px solid rgba(79, 172, 254, 0.4);
  color: var(--theme-text-primary);
}

.alert-warning svg {
  flex-shrink: 0;
  color: #ffc107;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.alert-info svg {
  flex-shrink: 0;
  color: #00bcd4;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.alert-content {
  flex: 1;
  color: var(--theme-text-primary);
  font-size: 0.875rem;
  line-height: 1.5;
}

.alert-content strong {
  font-weight: 700;
}

/* Sección de Confirmación */
.confirmation-section {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.875rem;
  background: var(--theme-hover-bg-light);
  border-radius: 8px;
  border: 1px solid var(--theme-border-color-strong);
  animation: fadeInUp 0.4s ease-out;
  margin-top: 1rem;
}

.confirmation-message {
  color: var(--theme-text-primary);
  line-height: 1.5;
  font-size: 0.9rem;
}

.confirmation-data {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.data-item {
  padding: 0.5rem 0.75rem;
  background: var(--theme-input-bg);
  border-radius: 6px;
  border-left: 3px solid var(--app-primary-blue);
  color: var(--theme-text-primary);
  font-size: 0.85rem;
}

.data-item strong {
  color: var(--app-primary-blue);
  font-weight: 700;
  margin-right: 0.5rem;
}

/* Mensaje de Error */
.message-card {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-shadow: var(--theme-shadow-md);
  backdrop-filter: var(--theme-backdrop-blur);
  animation: fadeInUp 0.6s ease-out;
  color: var(--theme-text-primary);
  text-align: center;
  min-height: 110px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

/* Botones de Acción */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--theme-border-color-light);
  flex-wrap: wrap;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 42px;
  padding: 0.625rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--theme-shadow-sm);
}

.btn-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--theme-shadow-md);
}

.btn-action:active:not(:disabled) {
  transform: translateY(0);
}

.btn-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-action:focus-visible {
  outline: 2px solid var(--app-primary-blue);
  outline-offset: 2px;
}

.btn-action svg {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.btn-danger {
  background: var(--theme-color-danger);
  border-color: var(--theme-color-danger);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #d32f2f;
}

.btn-info {
  background: var(--theme-color-info);
  border-color: var(--theme-color-info);
  color: white;
}

.btn-info:hover:not(:disabled) {
  background: #0288d1;
}

.btn-success {
  background: var(--theme-color-success);
  border-color: var(--theme-color-success);
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #43a047;
}

.btn-primary {
  background: var(--app-primary-blue);
  border-color: var(--app-primary-blue);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #0a3d6b;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--theme-overlay-bg);
  backdrop-filter: var(--theme-backdrop-blur);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: var(--theme-bg-secondary);
  border: 1px solid var(--theme-border-color);
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
  box-shadow: var(--theme-shadow-xl);
  animation: modalSlideUp 0.3s ease-out;
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--theme-border-color);
}

.modal-header h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--theme-text-primary);
  margin: 0;
}

.btn-close-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 8px;
  color: var(--theme-text-primary);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-close-modal:hover {
  background: var(--theme-hover-bg);
  transform: rotate(90deg);
}

.modal-body {
  padding: 1.5rem;
  color: var(--theme-text-primary);
  text-align: center;
  font-size: 0.9rem;
}

.modal-footer {
  display: flex;
  justify-content: center;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--theme-border-color);
}

/* Modal Transitions */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-active .modal-content,
.modal-fade-leave-active .modal-content {
  transition: transform 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .modal-content,
.modal-fade-leave-to .modal-content {
  transform: translateY(40px) scale(0.95);
}

/* Responsive */
@media (max-width: 768px) {
  .validation-intro {
    display: none;
  }

  .certificate-container {
    padding: 0 1rem;
  }

  .validation-card {
    padding: 1rem;
  }

  .validation-item {
    padding: 0.75rem;
  }

  .validation-details {
    flex-direction: column;
    align-items: stretch;
    gap: 0.625rem;
  }

  .question-value {
    width: 100%;
  }

  .validation-controls {
    width: 100%;
    justify-content: stretch;
  }

  .radio-group {
    width: 100%;
    flex-wrap: nowrap;
    justify-content: stretch;
    gap: 0.625rem;
  }

  .radio-button {
    flex: 1 1 0;
  }

  .radio-button span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 44px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-action {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .validation-card {
    padding: 0.75rem;
  }

  .validation-item {
    padding: 0.625rem;
  }

  .question-label {
    font-size: 0.85rem;
  }

  .question-value {
    font-size: 0.8rem;
  }
}
</style>
